import React from 'react';
export const ModelDetailsModal = ({
  model,
  onClose,
  onViewErrors
}) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-621">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md" data-id="element-622">
        <div className="flex justify-between items-center border-b border-gray-200 px-6 py-4" data-id="element-623">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-624">
            Model: {model.name}
          </h3>
          <button className="text-gray-400 hover:text-gray-500" onClick={onClose} data-id="element-625">
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-626">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-627" />
            </svg>
          </button>
        </div>
        <div className="p-6" data-id="element-628">
          <div className="mb-6" data-id="element-629">
            <div className="flex items-start mb-4" data-id="element-630">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-500 mr-3 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-631">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" data-id="element-632" />
              </svg>
              <div data-id="element-633">
                <h4 className="font-medium text-gray-900" data-id="element-634">Model Information</h4>
                <p className="text-sm text-gray-500" data-id="element-635">
                  Detailed information about this model.
                </p>
              </div>
            </div>
            <div className="flex items-start mb-4" data-id="element-636">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400 mr-3 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-637">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" data-id="element-638" />
              </svg>
              <div data-id="element-639">
                <h4 className="font-medium text-gray-700" data-id="element-640">Model Type</h4>
                <p className="text-sm text-gray-900" data-id="element-641">{model.type}</p>
              </div>
            </div>
            <div className="flex items-start mb-4" data-id="element-642">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400 mr-3 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-643">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-644" />
              </svg>
              <div data-id="element-645">
                <h4 className="font-medium text-gray-700" data-id="element-646">Last Updated</h4>
                <p className="text-sm text-gray-900" data-id="element-647">{model.lastUpdate}</p>
              </div>
            </div>
            <div className="flex items-start mb-4" data-id="element-648">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400 mr-3 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-649">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-650" />
              </svg>
              <div data-id="element-651">
                <h4 className="font-medium text-gray-700" data-id="element-652">Accuracy Rating</h4>
                <p className="text-sm text-gray-900" data-id="element-653">{model.accuracy}</p>
              </div>
            </div>
            {model.status === 'error' && <div className="flex items-start" data-id="element-654">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-500 mr-3 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-655">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-656" />
                </svg>
                <div data-id="element-657">
                  <h4 className="font-medium text-red-600" data-id="element-658">Status</h4>
                  <p className="text-sm text-red-600" data-id="element-659">
                    {model.errorCount} Errors detected
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-660">
                    Please check the model configuration and try again.
                  </p>
                </div>
              </div>}
          </div>
          <div className="flex justify-between gap-3" data-id="element-661">
            {model.status === 'error' && <button className="px-4 py-2 border border-red-300 text-red-700 rounded-md hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2" onClick={onViewErrors} data-id="element-662">
                View Errors
              </button>}
            <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2" data-id="element-663">
              Edit Model
            </button>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-664">
              Retrain Model
            </button>
          </div>
        </div>
      </div>
    </div>;
};